import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'

const PackageSelectionRecommendation = styled(Caption).attrs({ variant: 'medium' })`
  padding: ${rem(8)} ${rem(16)};
  margin-block-start: ${rem(-16)};
  margin-inline: ${rem(-16)};
  border-radius: 0;
  border-start-start-radius: calc(${props => props.theme.borderRadius.M} - 1px);
  border-start-end-radius: calc(${props => props.theme.borderRadius.M} - 1px);
  background-color: var(--palette-messaging-success-light-background);
  color: var(--palette-messaging-success-light-contrast);

  ${mediaQueryUp.tablet} {
    margin: 0;
    border-radius: ${props => props.theme.borderRadius.M};
  }
`

export default PackageSelectionRecommendation
